import React from 'react';
import { ChefHat, Sparkles, Calendar, Bell, Users, Volume2 } from 'lucide-react';
export const SilentDeathSection = () => {
  return <section className="w-full py-20 bg-gray-100" data-id="element-304">
      <div className="max-w-6xl mx-auto px-4" data-id="element-305">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16" data-id="element-306">
          "ŚMIERTELNE MILCZENIE"
        </h2>
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-307">
          <div className="w-full md:w-1/2" data-id="element-308">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sxYXSk9EAd6ibVa7Rr11cC/421a50a7-54bc-4610-b313-526e4f5d9e53.png" alt="Para przy stole, cisza, brak kontaktu wzrokowego" className="w-full rounded-lg shadow-xl" data-id="element-309" />
            <div className="mt-6 bg-white p-4 rounded-lg shadow" data-id="element-310">
              <div className="flex items-center justify-between" data-id="element-311">
                <div className="h-1 bg-gray-200 rounded-full w-full" data-id="element-312">
                  <div className="h-1 bg-blue-500 rounded-full w-1/3 animate-pulse" data-id="element-313"></div>
                </div>
                <div className="ml-4 text-sm text-gray-500" data-id="element-314">
                  słyszysz bicie swojego serca w ciszy
                </div>
              </div>
              <div className="mt-4 w-full h-16 bg-gray-100 rounded-lg p-2" data-id="element-315">
                <div className="relative h-full" data-id="element-316">
                  <div className="absolute inset-x-0 top-0 h-full" data-id="element-317">
                    <div className="w-full h-full flex items-center" data-id="element-318">
                      <div className="w-1 h-8 bg-red-400 mx-1 animate-pulse" data-id="element-319"></div>
                      <div className="w-1 h-4 bg-red-400 mx-1 animate-pulse" data-id="element-320"></div>
                      <div className="w-1 h-12 bg-red-400 mx-1 animate-pulse" data-id="element-321"></div>
                      <div className="w-1 h-6 bg-red-400 mx-1 animate-pulse" data-id="element-322"></div>
                      <div className="w-1 h-2 bg-red-400 mx-1 animate-pulse" data-id="element-323"></div>
                      <div className="w-1 h-8 bg-red-400 mx-1 animate-pulse" data-id="element-324"></div>
                      <div className="w-1 h-5 bg-red-400 mx-1 animate-pulse" data-id="element-325"></div>
                      <div className="w-1 h-10 bg-red-400 mx-1 animate-pulse" data-id="element-326"></div>
                      <div className="w-1 h-7 bg-red-400 mx-1 animate-pulse" data-id="element-327"></div>
                      <div className="w-1 h-3 bg-red-400 mx-1 animate-pulse" data-id="element-328"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/2" data-id="element-329">
            <ul className="space-y-6" data-id="element-330">
              <li className="flex items-center" data-id="element-331">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-332">
                  <ChefHat className="w-6 h-6 text-red-600" data-id="element-333" />
                </div>
                <div data-id="element-334">
                  <h3 className="text-xl font-bold" data-id="element-335">gotuje</h3>
                  <p className="text-gray-600" data-id="element-336">
                    Nikt nie zauważa godzin spędzonych w kuchni
                  </p>
                </div>
              </li>
              <li className="flex items-center" data-id="element-337">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-338">
                  <Sparkles className="w-6 h-6 text-red-600" data-id="element-339" />
                </div>
                <div data-id="element-340">
                  <h3 className="text-xl font-bold" data-id="element-341">sprząta</h3>
                  <p className="text-gray-600" data-id="element-342">
                    Czystość jest oczywista, bałagan zauważalny
                  </p>
                </div>
              </li>
              <li className="flex items-center" data-id="element-343">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-344">
                  <Calendar className="w-6 h-6 text-red-600" data-id="element-345" />
                </div>
                <div data-id="element-346">
                  <h3 className="text-xl font-bold" data-id="element-347">organizuje</h3>
                  <p className="text-gray-600" data-id="element-348">
                    Kalendarz rodziny na jej głowie
                  </p>
                </div>
              </li>
              <li className="flex items-center" data-id="element-349">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-350">
                  <Bell className="w-6 h-6 text-red-600" data-id="element-351" />
                </div>
                <div data-id="element-352">
                  <h3 className="text-xl font-bold" data-id="element-353">przypomina</h3>
                  <p className="text-gray-600" data-id="element-354">
                    Wiecznie narzekająca, nigdy doceniana
                  </p>
                </div>
              </li>
              <li className="flex items-center" data-id="element-355">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-356">
                  <Users className="w-6 h-6 text-red-600" data-id="element-357" />
                </div>
                <div data-id="element-358">
                  <h3 className="text-xl font-bold" data-id="element-359">siedzi naprzeciwko</h3>
                  <p className="text-gray-600" data-id="element-360">
                    On przeżuwa w milczeniu, patrząc w telefon
                  </p>
                </div>
              </li>
              <li className="flex items-center" data-id="element-361">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-362">
                  <Volume2 className="w-6 h-6 text-red-600" data-id="element-363" />
                </div>
                <div data-id="element-364">
                  <h3 className="text-xl font-bold" data-id="element-365">słucha</h3>
                  <p className="text-gray-600" data-id="element-366">
                    Dzieci gadają o swoich sprawach, a ja? Jestem tłem
                  </p>
                </div>
              </li>
            </ul>
            <div className="mt-12" data-id="element-367">
              <h2 className="text-5xl md:text-7xl font-extrabold text-gray-300 text-center" data-id="element-368">
                BYŁAM TŁEM
              </h2>
              <p className="text-center text-red-500 font-bold text-2xl mt-4" data-id="element-369">
                NIEWIDZIALNĄ KOBIETĄ
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};